import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = ['select']
  static values = { searchUrl: String }

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      searchField: ['value', 'text'],
      placeholder: 'Search ICD-10 code...',
      allowEmptyOption: true,
      preload: 'focus',
      dropdownParent: 'body',
      load: (query, callback) => {
        fetch(`${this.searchUrlValue}?q=${encodeURIComponent(query)}`)
          .then(r => r.json())
          .then(data => callback(data.map(item => ({ value: item.value, text: item.text }))))
          .catch(() => callback())
      },
      render: {
        no_results: () => '<div class="no-results px-3 py-2 text-sm text-gray-500">No matching ICD codes found</div>',
        loading: () => '<div class="px-3 py-2 text-sm text-gray-400">Searching...</div>'
      }
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
